import Modal from "components/common/controls/modal/Modal";
import CurrentUserResponse from "interfaces/response/CurrentUserResponse";
import { connect } from "react-redux";
import { RootState } from "store/store";
import UserAccountEditForm from "./UserAccountEditForm";

interface Props {
  onClose: () => void;
  user?: CurrentUserResponse | null;
}

export function UserAccountEditorPopup(props: Props) {
  const { onClose, user } = props;

  return (
    <div>
      <Modal
        visible={true}
        onClose={onClose}
        height={"auto"}
        maxWidth="471"
        title={"Account Details"}
        displayDefaultActions={false}
      >
        <div className="mb-6">
          Your account details are used for verification during login. For
          security reasons we will ask you to validate any changes you make to
          your email or phone number.
        </div>
        <div className="pb-10">
          <UserAccountEditForm user={user} onSuccess={onClose} onCancel={onClose} />
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    user: state.userData.currentUserDetail,
  };
};

export default connect(mapStateToProps)(UserAccountEditorPopup);
